import { createSlice } from "@reduxjs/toolkit";
import { Routes, routerChangeAction } from "const";
import cloneDeep from "lodash/cloneDeep";
import moment from "moment-timezone";

function past3MonthRangeDate() {
  return [moment().subtract(3, "month"), moment()];
}

const initialState = {
  loadingPortInfo: false,
  loadingTransactions: false,
  portInfo: {},
  transactions: [],
  numberOfPendingTrans: null,
  notYetRegistered: false,
  filterTransactionDate: past3MonthRangeDate(),
};

const slice = createSlice({
  initialState: cloneDeep(initialState),
  name: "lombard",
  extraReducers: (builder) => {
    builder.addCase(routerChangeAction, (state, { payload }) => {
      if (payload.location.pathname === Routes.LombardLoan) {
        state.filterTransactionDate = past3MonthRangeDate();
      }
    });
  },
  reducers: {
    getLombardPortId: (state) => {
      state.loading = true;
      state.notYetRegistered = false;
    },
    getLombardPortIdSuccess: (state, action) => {
      state.loading = false;
      state.portInfo = action.payload;
      state.notYetRegistered = !action.payload?.portId;
    },
    getLombardPortIdFailure: (state) => {
      state.loading = false;
      state.portInfo = cloneDeep(initialState.portInfo);
    },
    getLombardTransactions: (state, action) => {
      state.loadingTransactions = true;
      if (action.payload?.filterTransactionDate !== undefined) {
        state.filterTransactionDate = action.payload?.filterTransactionDate ?? [];
      }
      state.transactions = [];
      state.numberOfPendingTrans = 0;
    },
    getLombardTransactionsSuccess: (state, action) => {
      state.loadingTransactions = false;
      state.transactions = action.payload.transactions;
      state.numberOfPendingTrans = action.payload.numberOfPendingTrans;
    },
    getLombardTransactionsFailure: (state) => {
      state.loadingTransactions = false;
      state.transactions = [];
      state.numberOfPendingTrans = 0;
    },
    clearState: (state) => {
      state.notYetRegistered = false;
    },
    resetFilterTransactionDate: (state) => {
      state.filterTransactionDate = past3MonthRangeDate();
      state.transactions = [];
      state.numberOfPendingTrans = 0;
    },
  },
});

export const {
  getLombardPortId,
  getLombardPortIdSuccess,
  getLombardPortIdFailure,
  getLombardTransactions,
  getLombardTransactionsSuccess,
  getLombardTransactionsFailure,
  clearState,
  resetFilterTransactionDate,
} = slice.actions;

export default slice;
